  import { useState, useEffect, useCallback } from 'react';
  import { EntInitialFilter } from '../../models/filters/initialFilter';
  import { EntRoleAvailableRoutes } from "../../models/rolesAvailableRoutes";

  interface UseGetDataOnScrollProps<T, F extends EntInitialFilter> {
    initialFilter: F;
    query: (filter: F) => any;
    fetchOnMount?: boolean;
  }

  const useGetDataOnScroll = <T, F extends EntInitialFilter>({
    initialFilter,
    query,
    fetchOnMount = true,
  }: UseGetDataOnScrollProps<T, F>) => {
    const [filter, setFilter] = useState<F>(initialFilter);
    const [data, setData] = useState<T[]>([]);
    const [fetching, setFetching] = useState<boolean>(fetchOnMount);
    const [currentPage, setCurrentPage] = useState<number>(0);
    const [totalPages, setTotalPages] = useState<number>(1);
    const [totalItems, setTotalItems] = useState<number>(0);
    const [access, setAccess] = useState<EntRoleAvailableRoutes | null>(null);

    const getData = useCallback(async () => {
      try {
        const response = await query(filter).unwrap();
        const result = response.res;

        if (result) {
          setData((prevData) => [...prevData, ...result.content]);
          setTotalPages(result.totalPages);
          setTotalItems(result.totalElements);
          setAccess(result.access)
          setCurrentPage((prevPage) => prevPage + 1);
          setFilter((prevFilter) => ({
            ...prevFilter,
            page: prevFilter.page + 1,
          }));
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setFetching(false);
      }
    }, [filter, query]);

    useEffect(() => {
      if (fetching) {
        getData();
      }
    }, [fetching, getData]);

    const scrollHandler = (e: any) => {
      const element = e.target;
      if (!fetching && element.scrollHeight - (element.scrollTop + element.clientHeight) < 100 && currentPage < totalPages) {

        setFetching(true);
      }
    };

    const loadData = () => {
      if (!fetching) {
        setFetching(true);
      }
    };

    return {
      filter,
      access,
      fetching,
      data,
      totalItems,
      setFilter,
      setData,
      setFetching,
      scrollHandler,
      setCurrentPage,
      loadData,
    };
  };

  export { useGetDataOnScroll };
